import React from "react";

const InnerContactInfo = () => {
  const info_items = [
    {
      src: "/img/icon/loction_icon03.png",
      title: "Adres",
      desc: (
        <p>
          Abtsweg 41A - 43A <br />
          3042 GA Rotterdam
        </p>
      ),
    },
    {
      src: "/img/icon/mail_icon03.png",
      title: "E-mailadres",
      desc: (
        <a href="mailto:info@dianakledingreparatie.nl">
          info@dianakledingreparatie.nl
        </a>
      ),
    },
    {
      src: "/img/icon/phone_icon03.png",
      title: "Telefoon",
      desc: <a href="tel:0614507471">06 - 14507471</a>,
    },
  ];

  return (
    <ul className="list-wrap">
      {info_items.map((item, index) => (
        <li key={index}>
          <div className="contact-info-item">
            <div className="icon">
              <img src={item.src} alt={`Icon voor ${item.title}`} />
            </div>
            <div className="content">
              <h6 className="title">{item.title}</h6>
              {item.desc}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default InnerContactInfo;
